import { render } from "./Projet-RLTS.vue?vue&type=template&id=ba67565c"
import script from "./Projet-RLTS.vue?vue&type=script&lang=js"
export * from "./Projet-RLTS.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__